/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{Geometry as o}from"./Geometry.js";class t extends o{}function e(o){return null!=o.mapPositions}export{t as GeometryWithMapPositions,e as isGeometryWithMapPositions};
